import isArray from 'lodash/isArray';

const normalizeHandlers = handlers =>
  isArray(handlers) ? handlers : [handlers];

export default normalizeHandlers;
